var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-method2';
                    var viewUrl = 'sprite.svg#view-icon-method2';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };